import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
import type ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

const setReactListViewTypeMutator: (listViewType: ReactListViewType) => void = mutatorAction(
    'setReactListViewType',
    (listViewType: ReactListViewType): void => {
        const store = getStore();
        store.listViewType = listViewType;
    }
);
export default setReactListViewTypeMutator;
